import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { UpdateUserType } from "types/UsersTypes";
import { queryClient } from "App";

export const useUpdateUser = (
  options?: UseMutationOptions<any, Error, UpdateUserType>
) => {
  return useMutation({
    ...options,
    mutationKey: ["updateUser"],
    mutationFn: async ({ id, name, email, role, password }) => {
      const payload: any = {
        name,
        role,
        email,
      };

      // Only include password if provided
      if (password) {
        payload.password = password;
      }

      return axiosInstance.put(`/users/${id}`, payload).then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Trwa aktualizacja konta...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "update-user",
      });
      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: "Pomyślnie zaktualizowano konto.",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "update-user",
      });
      queryClient.prefetchQuery({ queryKey: ["users"] });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error: any, variables, context) => {
      Toast({
        message: "Błąd podczas aktualizacji konta.",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "update-user",
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default useUpdateUser;
